/**
 * Lane 비공개 타일을 다른 자리에 끼워넣기(insertion)할 때
 * 사용자가 hover한 gap 인덱스를 서버 프로토콜 toIdx로 변환.
 *
 * Gap 인덱스 정의:
 *  - lane이 N개 셀이면 gap은 0..N
 *  - gap k = (k-1)번 셀과 k번 셀 사이의 빈 공간
 *  - gap 0 = lane 맨 왼쪽, gap N = lane 맨 오른쪽
 *
 * `SHUFFLE_DOWN_TILE`은 splice(remove fromIdx) → splice(insert toIdx) 쌍.
 * 따라서 fromIdx보다 큰 gap에 떨어뜨리면 splice 후 자리가 한 칸 당겨지는 점 보정.
 *
 * 자기 자신의 양옆 gap (fromIdx, fromIdx+1)은 결과적으로 같은 자리 → null 반환 (no-op).
 */
export function gapToTargetIdx(fromIdx: number, gap: number): number | null {
  const target = gap > fromIdx ? gap - 1 : gap;
  if (target === fromIdx) return null;
  return target;
}

/**
 * 셀의 좌/우 절반으로 gap 인덱스 판정.
 *  - 좌측 절반 → gap = cellIdx
 *  - 우측 절반 → gap = cellIdx + 1
 */
export function gapFromCellAndPoint(
  cellIdx: number,
  cellRect: { left: number; right: number },
  clientX: number,
): number {
  const mid = (cellRect.left + cellRect.right) / 2;
  return clientX < mid ? cellIdx : cellIdx + 1;
}
